/*
 * IconListSearch.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { BEM } from "@adapptio/lib-components";
import { FieldText, IFieldTextProps } from "../../fields";
import { useIconListContext } from "./IconListContext";

export interface IIconListSearchProps {
	className?: string;
}

export const IconListSearch: React.FC<IIconListSearchProps> = ({ className }) => {
	const { search, setSearch } = useIconListContext();
	const baseClass = BEM("edt-icon-list-search");

	const handleSearchChange = useCallback<IFieldTextProps["onChange"]>(
		(value) => {
			setSearch(value);
		},
		[ setSearch ]
	);

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<FieldText value={search} grow onChange={handleSearchChange} placeholder="Search..." autoFocus />
		</div>
	);
};
